import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import RichTextEditor from "../../TextEditor/RichTextEditor";
import TextLabel from "../../TextLabel";
import FileUpload from "../../../basic-component/uploadFile";
import { useSelector } from "react-redux";
import { Button, InputGroup } from "react-bootstrap";
import TextArea from "../../TextArea";
import axios from "axios";
import API_Routes from "../../../../../constants/api-routes";
import { Snackbar } from "@mui/material";
import {
  IconButton,
  Card,
  CardHeader,
  Checkbox,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grid,
  Button as MUIButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  apiHostUrl,
  closeFeedbackURL,
  getFeedbackDetailsforFeedbackCloseURL,
  logoutUrl,
  uploadFeedbackAttachment,
} from "../../../../../constants/constants";
import PluginSnackbar from "../../../basic-component/Snackbar";
import { setResponsePendingReducer } from "../../../../system/redux/reducers/ResponsePendingReducer";
//import { TransferList, TransferListList } from "react-transfer-list";

// Bootstrap
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import { Tab, Nav, Card as BootStrapCard } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import { useRef } from "react";
import {
  checkImageSignatureAndSize,
  clearFileInput,
  clickFileInput,
  handleFileChange,
  postActionDataRefresh,
  removeHTMLElements,
} from "../../CommonUtils";
import useAxiosFetchData from "../../../../hooks/useAxiosFetchData";
import ShowDataTable from "../../Tables/ShowDataTable";
import { useDispatch } from "react-redux";
import { setCCEmailReducer } from "../../../../system/redux/reducers/CCEmailReducer";
import { set } from "react-hook-form";
import { setReloadFeedbackDetails } from "../../../../system/redux/reducers/reloadFeedbackDetails";

const isObjectEmpty = (objectName) => {
  return (
    objectName &&
    Object.keys(objectName).length === 0 &&
    objectName.constructor === Object
  );
};
export default function FeedbackClosure({
  toggleParentModal,
  itemData,
  uploadFormData,
  receiptTargetId,
  snackBarSwitch,
  snackMsg,
  onModalCloseHandler,
  needsRefresh,
}) {
  console.log(itemData);
  const { closeFeedbackOnSubmit: OnSubmitResponsePending } = useSelector(
    (state) => state.ResponsePendingReducer
  );
  const [r, setR] = useState(0);
  const { i18n, t } = useTranslation();
  const { userId: bidderId } = useSelector((state) => state.role);
  const { csrfToken } = useSelector((state) => state.csrf);
  const [filename, setFilename] = useState("");
  const [preventiveAction, setPreventiveAction] = useState("");
  const [correctiveAction, setCorrectiveAction] = useState("");
  const [rootCause, setRootCause] = useState("");
  const [loggerResponse, setLoggerResponse] = useState("");
  const [isOpen, setIsopen] = useState(false);
  const dispatch = useDispatch();
  const ref = useRef(null);
  var isComplain = false;

  const handleFileNameChange = (val) => {
    //debugger;
    console.log(val);
    setFilename(val.toString());
  };
  /* const handleFileChange = (val) => {
    console.log(val);
    setFilename(val.toString());
  }; */
  const columnData = [
    t("general.message.select.label"),
    t("general.label.email"),
  ];
  const [rowsData, setRowsData] = useState([]);

  const { homeLink } = useSelector((state) => state.role);
  const fetchUrl = apiHostUrl + homeLink + uploadFeedbackAttachment;
  const [closeFeedbackresult, setCloseFeedbackResult] = useState("");
  const headers = {
    "Content-Type": "application/json",
    "X-CSRF-TOKEN": csrfToken,
  };

  const multiPartHeaders = {
    "Content-Type": "multipart/form-data",
    "X-CSRF-TOKEN": csrfToken,
  };

  const [error, setError] = useState(null);
  const [validationError, setValidationErrors] = useState({});
  console.log(itemData);
  console.log(uploadFormData);
  const handlePreventiveActionChange = (e) => {
    setPreventiveAction(e.target.value);
  };

  const handleCorrectiveActionChange = (e) => {
    setCorrectiveAction(e.target.value);
  };

  const handleRootCauseChange = (e) => {
    setRootCause(e.target.value);
  };

  const handleCloseSnack = () => {
    setIsopen(false);
  };

  const uploadFeedbackAttachemtURL =
    apiHostUrl + homeLink + uploadFeedbackAttachment;
  const formData = new FormData();
  formData.append("hiddenBidderId", bidderId);
  formData.append("_csrf", csrfToken);
  formData.append("_csrf", csrfToken);
  formData.append("fileName", "");
  formData.append("tagOldFeedback", "");

  const [
    fetchPayloadDataForFeedbackClose,
    setFetchPayloadDataForFeedbackClose,
  ] = useState(null);
  const [feedbackDetailsForFeedbackClose, setFeedbackDetailsForFeedbackClose] =
    useState(null);

  const { fetchData: fetchFeedbackDetailsForFeedbackClose } = useAxiosFetchData(
    {
      url: `${apiHostUrl}${homeLink}${getFeedbackDetailsforFeedbackCloseURL}`,
      method: "POST",
      headers: headers,
      body: fetchPayloadDataForFeedbackClose,
      onLoad: false,
    }
  );
  const [checkedArray, setCheckedArray] = useState([]);
  const handleEmailValueChange = (checkedIndex) => {
    // const checkedIndex = event.target.value; // Assuming the value of the checkbox corresponds to its index
    // console.log(event, checkedIndex, checkedArray);
    // debugger;
    // Check if the item at the checked index is already in the array
    const itemIndex = checkedArray.indexOf(
      feedbackDetailsForFeedbackClose.mailUsers[checkedIndex]
    );
    let hasElement = false;
    console.log(
      checkedArray.filter(
        (ele) =>
          ele.id === feedbackDetailsForFeedbackClose.mailUsers[checkedIndex].id
      )
    );
    if (
      checkedArray.filter(
        (ele) =>
          ele.id === feedbackDetailsForFeedbackClose.mailUsers[checkedIndex].id
      ).length > 0
    ) {
      //   debugger;
      hasElement = true;
    }
    // debugger;

    if (hasElement) {
      // If the item is found, remove it from the array
      setCheckedArray((prevCheckedArray) => {
        const newCheckedArray = prevCheckedArray.filter(
          (ele) =>
            ele.id !==
            feedbackDetailsForFeedbackClose.mailUsers[checkedIndex].id
        );
        // debugger;
        return newCheckedArray;
      });
    } else {
      // If the item is not found, add it to the array
      setCheckedArray((prevCheckedArray) => {
        const newCheckedArray = [...prevCheckedArray];
        newCheckedArray.push(
          feedbackDetailsForFeedbackClose.mailUsers[checkedIndex]
        );
        return newCheckedArray;
      });
    }
    // debugger;
  };
  useEffect(() => {
    if (
      itemData !== null &&
      itemData !== undefined &&
      !isObjectEmpty(itemData)
    ) {
      setFetchPayloadDataForFeedbackClose({
        departmentId: itemData.departmentId,
        feedbackId: itemData.feedbackId
          ? itemData.feedbackId
          : itemData.feedback_id,
        receiptTargetId: itemData.receipts.receiptTargetId,
      });
    }
  }, [itemData]);
  useEffect(() => {
    if (
      fetchPayloadDataForFeedbackClose !== null &&
      fetchPayloadDataForFeedbackClose !== undefined
    ) {
      fetchFeedbackDetailsForFeedbackClose().then((response) => {
        setFeedbackDetailsForFeedbackClose(response);
      });
    }
  }, [fetchPayloadDataForFeedbackClose]);
  const { value: CCEmailIndexValue } = useSelector(
    (state) => state.CCEmailReducer
  );
  useEffect(() => {
    if (CCEmailIndexValue >= 0) {
      handleEmailValueChange(CCEmailIndexValue);
      dispatch(setCCEmailReducer(-1));
    }
  }, [CCEmailIndexValue]);
  useEffect(() => {
    if (
      feedbackDetailsForFeedbackClose !== null &&
      feedbackDetailsForFeedbackClose !== undefined &&
      feedbackDetailsForFeedbackClose.mailUsers !== null &&
      feedbackDetailsForFeedbackClose.mailUsers !== undefined
    ) {
      feedbackDetailsForFeedbackClose.mailUsers.forEach((item, index) => {
        setRowsData((prevData) => [
          ...prevData,
          [
            <input
              inline
              label=""
              value={index}
              name="group1"
              type={"checkbox"}
              id={`inline-checkbox-${index}`}
              checked={checkedArray[index]}
              onChange={(event) => {
                const checkedIndex = event.target.value; // Assuming the value of the checkbox corresponds to its index
                dispatch(setCCEmailReducer(Number(checkedIndex)));
                // console.log(event, checkedIndex, memoizedCheckedArray);
                // debugger;
                // // Check if the item at the checked index is already in the array
                // const itemIndex = memoizedCheckedArray.indexOf(
                //   feedbackDetailsForFeedbackClose.mailUsers[checkedIndex]
                // );
                // let hasElement = false;
                // console.log(
                //   memoizedCheckedArray.filter(
                //     (ele) =>
                //       ele.id ===
                //       feedbackDetailsForFeedbackClose.mailUsers[checkedIndex].id
                //   )
                // );
                // if (
                //   memoizedCheckedArray.filter(
                //     (ele) =>
                //       ele.id ===
                //       feedbackDetailsForFeedbackClose.mailUsers[checkedIndex].id
                //   ).length > 0
                // ) {
                //   debugger;
                //   hasElement = true;
                // }
                // debugger;

                // if (hasElement) {
                //   // If the item is found, remove it from the array
                //   setCheckedArray((prevCheckedArray) => {
                //     const newCheckedArray = prevCheckedArray.filter(
                //       (ele) =>
                //         ele.id !==
                //         feedbackDetailsForFeedbackClose.mailUsers[checkedIndex]
                //           .id
                //     );
                //     debugger;
                //     return newCheckedArray;
                //   });
                // } else {
                //   // If the item is not found, add it to the array
                //   setCheckedArray((prevCheckedArray) => {
                //     const newCheckedArray = [...prevCheckedArray];
                //     newCheckedArray.push(
                //       feedbackDetailsForFeedbackClose.mailUsers[checkedIndex]
                //     );
                //     return newCheckedArray;
                //   });
                // }
                // debugger;
              }}
            />,
            `${item.firstName} ${item.lastName} <${item.email}>`,
          ],
        ]);
      });
    }
  }, [feedbackDetailsForFeedbackClose]);

  const validForm = () => {
    let validationError = {};
    //debugger
    if (isComplain) {
      if (rootCause == "" || rootCause == null) {
        validationError.rootCause = t(
          "general.exception.errorMessage.feedbackDesc.rootcause"
        );
      }
      if (preventiveAction == "" || preventiveAction == null) {
        validationError.preventiveAction = t(
          "general.exception.errorMessage.feedbackDesc.preventiveaction"
        );
      }
      if (correctiveAction == "" || correctiveAction == null) {
        validationError.correctiveAction = t(
          "general.exception.errorMessage.feedbackDesc.correctiveaction"
        );
      }
    }
    var feedbackDescription = sessionStorage.getItem("editorContent");
    if (feedbackDescription && feedbackDescription.length > 0) {
      feedbackDescription = removeHTMLElements(feedbackDescription);
    }
    if (feedbackDescription === null || feedbackDescription == "") {
      console.log(
        "I am in feedback Discription" + sessionStorage.getItem("editorContent")
      );
      validationError.feedbackDesc = t("general.label.feedback.required");
    }

    //File input validation
    //debugger;
    var feedbackFiles = document.querySelectorAll(".feedback-close-file-list");
    if (feedbackFiles && feedbackFiles.length > 0) {
      for (var i = 0; i < feedbackFiles.length; i++) {
        var fullPath = feedbackFiles[i].value;
        if (fullPath) {
          var startIndex =
            fullPath.indexOf("\\") >= 0
              ? fullPath.lastIndexOf("\\")
              : fullPath.lastIndexOf("/");
          var filename = fullPath.substring(startIndex);
          if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
            filename = filename.substring(1);
          }
          var fileErrors = [];
          checkImageSignatureAndSize(feedbackFiles[i], fileErrors, null, null, null);
          //debugger;
          if (fileErrors?.length > 0) {
            validationError.fileUpload = fileErrors[0];
            setError(t("general.exception.errorMessage.fileUpload"));
          }
        }
      }
    }

    setValidationErrors(validationError);
    return Object.keys(validationError).length === 0;
  };
  const resolveFeedback = async (event) => {
    event.preventDefault();
    console.log("BUTTON CLICKED");
    console.log("item data", itemData);
    if (validForm()) {
      const resolvePayload = {
        departmentId: itemData.departmentId,
        feedbackId: itemData.feedbackId
          ? itemData.feedbackId
          : itemData.feedback_id,
        feedbackType: {
          feedbackType: itemData.feedbackType.description,
        },
        latestReceipt: {
          receiptTargetId: receiptTargetId,
        },
        mailUsers: checkedArray,
        resolution: {
          correctiveAction: correctiveAction,
          loggerResponse: sessionStorage.getItem("editorContent"),
          preventiveAction: preventiveAction,
          responseFileName: "",
          rootCause: rootCause,
        },
      };
      console.log("resolve payload", resolvePayload);

      var feedbackDescription = sessionStorage.getItem("editorContent");
      if (feedbackDescription && feedbackDescription.length > 0) {
        feedbackDescription = removeHTMLElements(feedbackDescription);
      }
      if (
        feedbackDescription === null ||
        feedbackDescription == "" ||
        feedbackDescription.length === 0
      ) {
        setError(t("general.label.feedback.required"));
        return; // Do not proceed with form submission
      }

      // New FormData to append file and user data
      let formData = new FormData();

      formData.append("_csrf", csrfToken);
      formData.append("departmentId", itemData.departmentId);
      formData.append(
        "feedbackId",
        itemData.feedbackId ? itemData.feedbackId : itemData.feedback_id
      );
      formData.append(
        "feedbackType.feedbackType",
        itemData.feedbackType.description
      );
      formData.append("latestReceipt.receiptTargetId", receiptTargetId);
      formData.append("resolution.correctiveAction", correctiveAction);
      formData.append(
        "resolution.loggerResponse",
        sessionStorage.getItem("editorContent")
      );
      formData.append("resolution.preventiveAction", preventiveAction);
      formData.append("resolution.responseFileName", "");
      formData.append("resolution.rootCause", rootCause);

      //debugger;
      if (checkedArray != null && checkedArray.length > 0) {
        for (var i = 0; i < checkedArray.length; i++) {
          var mailUser = checkedArray[i];
          for (var prop in mailUser) {
            console.log(prop + ": " + mailUser[prop]);
            formData.append("mailUsers[" + i + "]." + prop, mailUser[prop]);
          }
        }
      }

      //File input
      var feedbackFiles = document.querySelectorAll(
        ".feedback-close-file-list"
      );
      if (feedbackFiles && feedbackFiles.length > 0) {
        for (var i = 0; i < feedbackFiles.length; i++) {
          var fullPath = feedbackFiles[i].value;
          if (fullPath) {
            var startIndex =
              fullPath.indexOf("\\") >= 0
                ? fullPath.lastIndexOf("\\")
                : fullPath.lastIndexOf("/");
            var filename = fullPath.substring(startIndex);
            if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
              filename = filename.substring(1);
            }
            //alert(filename);
            if (filename) {
              formData.append(
                "addFileList[" + i + "].multipartFile",
                feedbackFiles[i].files[0]
              );
              formData.append("addFileList[" + i + "].fileName", filename);
            }
          }
        }
      }

      setError(null);
      //debugger;
      //if(true){return;}
      dispatch(setResponsePendingReducer({ closeFeedbackOnSubmit: true }));

      await axios
        .post(apiHostUrl + homeLink + closeFeedbackURL, formData, {
          withCredentials: true,
          headers: multiPartHeaders,
        })
        .then((data) => {
          dispatch(setResponsePendingReducer({ closeFeedbackOnSubmit: false }));
          //debugger;
          console.log(data.data);
          snackBarSwitch(true);
          if (data.data.status === true) {
            snackMsg(t(`${data.data.message}`));
            setPreventiveAction("");
            setCorrectiveAction("");
            setRootCause("");

            postActionDataRefresh(4, null);

            onModalCloseHandler();
            if (needsRefresh === true)
              dispatch(setReloadFeedbackDetails({ value: true }));
          } else {
            snackMsg(t(`${data.data.message}`));
            onModalCloseHandler();
            if (needsRefresh === true)
              dispatch(setReloadFeedbackDetails({ value: true }));
          }
          console.log("hi");

          console.log(data.data);

          setCloseFeedbackResult(data.data);
          // setIsopen(true);
          sessionStorage.setItem("editorContent", "");
          // toggleParentModal();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth" });
      console.log("error");
    }
    // await yourAsyncLogic();

    // formRef.current.submit();
    // window.location.reload();
  };
  const action = (
    <React.Fragment>
      {/* <Button color="secondary" size="small" onClick={handleClose}>
                CLOSE
            </Button> */}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => handleCloseSnack}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  useEffect(() => {}, [
    rootCause,
    preventiveAction,
    correctiveAction,
    sessionStorage.getItem("editorContent"),
  ]);

  if (itemData.hasOwnProperty("departmentId")) {
    //debugger
    if (itemData.feedbackType.description === "COMPLAINT") {
      isComplain = true;
      console.log("hi");
    }
  }
  console.log("isComplain---- =" + isComplain);
  return (
    <Row ref={ref}>
      {/* <div>
                <h1>{t('general.lable.feedbackClosure')}</h1>
                <h1 style={{ borderBottom: '1px solid', paddingBottom: '10px' }}></h1>
            </div> */}
      <Col lg="12" className="mb-3">
        <Form.Label className="fw-medium">
          {t("feedbackDetails.rootCause.text")}
          <span className="text-danger" hidden={!isComplain}>
            *
          </span>
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          id="root-cause"
          value={rootCause}
          onChange={handleRootCauseChange}
        />
        {validationError.rootCause && (
          <span className="text-danger">{validationError.rootCause}</span>
        )}
        {/* <TextLabel title={t('feedbackDetails.rootCause.text')} isMandatory={true}></TextLabel> */}
        {/* <TextArea id="preventiveAction" value={rootCause} onChange={handleRootCauseChange}
                    styles={{ height: '70px' }} isRequired={true}></TextArea> */}
      </Col>

      <Col lg="6" className="mb-3">
        <Form.Label className="fw-medium">
          {t("feedbackDetails.preventiveAction.text")}
          <span className="text-danger" hidden={!isComplain}>
            *
          </span>
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          id="preventiveAction"
          value={preventiveAction}
          onChange={handlePreventiveActionChange}
          required="true"
        />
        {validationError.preventiveAction && (
          <span className="text-danger">
            {validationError.preventiveAction}
          </span>
        )}
        {/* <TextLabel title={t('feedbackDetails.preventiveAction.text')} isMandatory={true}></TextLabel> */}
        {/* <TextArea id="preventiveAction" value={preventiveAction} onChange={handlePreventiveActionChange}
                    styles={{ height: '70px' }} isRequired={true}></TextArea> */}
      </Col>

      <Col lg="6" className="mb-3">
        <Form.Label className="fw-medium">
          {t("feedbackDetails.correctiveAction.text")}
          <span className="text-danger" hidden={!isComplain}>
            *
          </span>
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          id="correctiveAction"
          value={correctiveAction}
          onChange={handleCorrectiveActionChange}
          required="true"
        />
        {validationError.correctiveAction && (
          <span className="text-danger">
            {validationError.correctiveAction}
          </span>
        )}
        {/* <TextLabel title={t('feedbackDetails.correctiveAction.text')} isMandatory={true}></TextLabel> */}
        {/* <TextArea id="correctiveAction" value={correctiveAction} onChange={handleCorrectiveActionChange}
                    isRequired={true} styles={{ height: '70px' }}  ></TextArea> */}
      </Col>

      <Col lg="12" className="mb-3">
        <Form.Label className="fw-medium">
          {t("feedbackDetails.responseToLogger.text")}
          <span className="text-danger">*</span>
          <br/>{t("general.error.rootCauseSize.maxLength")}
        </Form.Label>

        {/* <TextLabel title={t('general.label.richTextEditortext')} isMandatory={true}></TextLabel> */}
        <RichTextEditor reset={r}></RichTextEditor>
      </Col>

      {feedbackDetailsForFeedbackClose &&
        feedbackDetailsForFeedbackClose.mailUsers &&
        feedbackDetailsForFeedbackClose.mailUsers.length > 0 && (
          <Col lg="12" className="mb-3">
            <Form.Label className="fw-medium">
              {t(
                "close.feedback.message.closure.mail.user.selection.panel.header"
              )}
            </Form.Label>
            <BootStrapCard className="mb-3 overflow-hidden">
              <BootStrapCard.Header className="light-blue-bg fw-medium">
                {t(
                  "close.feedback.message.closure.mail.user.selection.head.instruction"
                )}
              </BootStrapCard.Header>
              <BootStrapCard.Body className="p-0">
                <ShowDataTable columns={columnData} rows={rowsData} />
              </BootStrapCard.Body>
            </BootStrapCard>
          </Col>
        )}
      {validationError.feedbackDesc && (
        <span className="text-danger">{validationError.feedbackDesc}</span>
      )}
      <Col lg="12" className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <TextLabel
            title={t("general.button.uploadFile")}
            isMandatory={false}
            subLabel={
              " .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"
            }
          ></TextLabel>
          <br />

          {/* <Button variant="outline-primary" className="float-end py-0 mb-1" size="sm">
                <i class="ti ti-plus"></i> Add More
              </Button> */}

          <Form.Label className={"fw-medium feedback-add-files"}>
            {" "}
            {t("general.error.chooseFile.size")}{" "}
          </Form.Label>
          <InputGroup className="custom-file-uploader">
            <InputGroup.Text
              id="basic-addon1"
              onClick={(e) => clickFileInput(e, ".feedback-close-file-list")}
              className="text-section float-start start-0 w-100 bg-body-secondary p-0 z-0 position-relative rounded"
            >
              <div className="p-2 me-2 border-end bg-body-secondary">
                {t("general.label.choose.file")}
              </div>
              <div className="file-name-label">
                {t("general.label.no.file.chosen")}
              </div>
            </InputGroup.Text>
            <FileUpload
              className={"feedback-close-file-list d-none"}
              fileTypes={
                " .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"
              }
              bidderId={bidderId}
              data={formData}
              onChange={(e) => {
                handleFileChange(e, ".file-name-label");
                handleFileNameChange(e);
              }}
              fetchUrl={uploadFeedbackAttachemtURL}
            ></FileUpload>
            <span
              onClick={(e) => clearFileInput(e, ".feedback-close-file-list")}
              className="py-1"
            >
              <Button variant="link" className="border-0 text-decoration-none">
                <i class="ti ti-x"></i>
              </Button>
            </span>
          </InputGroup>
          {validationError.fileUpload && (
            <span className="text-danger">{validationError.fileUpload}</span>
          )}
        </Form.Group>
      </Col>

      <Col lg="12" className="mb-3 text-end">
        <Button
          variant=""
          className="btn-primary-outline border m-3"
          onClick={onModalCloseHandler}
        >
          {t("general.button.cancel.label")}
        </Button>
        <Button
          variant="primary"
          disabled={OnSubmitResponsePending}
          onClick={(e) => {
            resolveFeedback(e);
          }}
        >
          {t("general.button.submit.label")}{" "}
          {OnSubmitResponsePending && (
            <span className="spinner-border spinner-border-sm ml-2"></span>
          )}
        </Button>
      </Col>

      {/* <Snackbar
                open={isOpen}
                autoHideDuration={5000}
                onClose={handleCloseSnack}
                message={closeFeedbackresult}
                action={action}
            ></Snackbar> */}
      <PluginSnackbar
        open={isOpen}
        message={closeFeedbackresult}
        onClose={handleCloseSnack}
      />
    </Row>
  );
}
